// extracted by mini-css-extract-plugin
export default {"usersTable":"usersTable_usersTable__baAAO","tableHead":"usersTable_tableHead__Zgh4X"};